import tabla_usuarios from "../../../components/shared/tabla_cv/tabla.vue"

export default {

  components: { tabla_usuarios },
  data() {
    return {
      tab: null,

      columnas: [
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
        },
        {
          text: "CUI/DPI",
          align: "center",
          sortable: true,
          value: "cui"
        },
        {
          text: "NIT",
          align: "center",
          sortable: true,
          value: "nit",
        },
        {
          text: "Dirección",
          align: "center",
          sortable: true,
          value: "direccion",
        },
        {
          text: "Teléfono",
          align: "center",
          sortable: true,
          value: "telefono[0].telefono",
        },

        {
          text: "Correo",
          align: "center",
          sortable: true,
          value: "correo[0].correo"
        },
        {
          text: "Fecha declaración",
          align: "center",
          sortable: true,
          value: "fecha_declaracion"
        },

        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "acciones",
        },
      ],
      filas: [],
      loading: false,
    }
  },

  created() {
    console.log('/reporte_compras_ventas.0');
    this.getUsuarios();
  },

  methods: {
    async getUsuarios() {
      this.loading = true;
      try {
        let r = await this.$store.state.services.administradorService.getUsuarios();
        console.log('getUsuarios', r);
        r.data.data.filter((x) => {
          x.nombre =
            (x.primer_nombre === null ? '' : x.primer_nombre) +
            " " +
            (x.segundo_nombre === null ? '' : x.segundo_nombre) +
            " " +
            (x.primer_apellido === null ? '' : x.primer_apellido) +
            " " +
            (x.segundo_apellido === null ? '' : x.segundo_apellido);
        });
        this.filas = r.data.data;
        this.loading = false;
      } catch (error) {
        this.$toast.error(
          "Ocurrió un error al obtener los datos de los empleados"
        );
        this.loading = false;
      }
    },
  },
}